import { Content, Item } from '@radix-ui/react-dropdown-menu';
import { styled } from '@sds-system/system';
import { theme } from '@sds-system/theme';
import { getAllStyledProps, processNestedCSS } from '@sds-system/utils';
import type {
  DropdownContentStyledProps,
  DropdownItemStyledProps,
  DropdownSizeKey,
} from './Dropdown.types';

const selectSizeStyle = (size?: DropdownSizeKey) => {
  switch (size) {
    case 'XL':
      return {
        height: '56px',
        ...theme.typography.body2.regular,
      };
    case 'L':
      return {
        height: '48px',
        ...theme.typography.body2.regular,
      };
    case 'M':
      return {
        height: '40px',
        ...theme.typography.body2.regular,
      };
    case 'S':
      return {
        height: '32px',
        padding: '0 12px',
        ...theme.typography.caption.regular,
      };
    default:
      return {
        height: '40px',
        ...theme.typography.body2.regular,
      };
  }
};

export const StyledDropdownContent = styled(Content)<DropdownContentStyledProps>(
  ({ theme, textAlign = 'start' }) => {
    return {
      marginTop: 4,
      borderRadius: 8,
      border: '1px solid',
      borderColor: theme.palette.border.tertiary,
      textAlign: textAlign,
      backgroundColor: theme.palette.bg.primary,
    };
  },
  getAllStyledProps,
);

export const StyledDropdownItem = styled(Item)<DropdownItemStyledProps>(({ theme, size }) => {
  return {
    padding: '0 16px',
    ...selectSizeStyle(size),
    display: 'flex',
    alignItems: 'center',
    outline: 'none',
    ':hover': processNestedCSS(
      {
        backgroundColor: theme.palette.bg.interactive.selectedHover,
      },
      theme,
    ),
    ':active': processNestedCSS(
      {
        backgroundColor: theme.palette.bg.interactive.selectedPressed,
      },
      theme,
    ),
  };
}, getAllStyledProps);
